import { getMeta } from '../utils/notification-helpers';
import NotificationIcon from '../NotificationIcon';
import TwygsAvatar from '../../../../assets/twygs-avatar-notification.svg';
import StarIcon from '../../../../assets/star-half.svg';
import ReactStackIcon from '../../../../assets/react-stack.svg';
import EyeIcon from '../../../../assets/eye-icon.svg';
import CommentIcon from '../../../../assets/comment-icon.svg';

const formatCount = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return '0';
  if (n >= 1000) return `${(n / 1000).toFixed(1).replace(/\.0$/, '')}k`;
  return new Intl.NumberFormat().format(n);
};

const ArticleMileStone1000Notification = ({ notification }) => {
  const meta = getMeta(notification);
  const milestone = meta.articleMilestone
    ? new Intl.NumberFormat().format(meta.articleMilestone)
    : null;

  return (
    <div className="flex items-start gap-2">
      <NotificationIcon avatarSrc={TwygsAvatar} subIcon={StarIcon} />
      <div className="ml-2 min-w-0 w-[85%]">
        <p className="text-sm text-growth-green-900">
          Congratulations! Your article reached{' '}
          <span className="font-extrabold text-growth-green">{milestone} views!</span>
        </p>

        {meta.articleTitle && (
          <p className="text-sm font-bold text-growth-green-900 mt-1">
            &ldquo;{meta.articleTitle}&rdquo;
          </p>
        )}

        <div className="flex items-center gap-3 mt-2 text-xs text-gray-700">
          {meta.articleViewNumber != null && (
            <span className="flex items-center gap-1">
              <img src={EyeIcon} alt="views" className="w-4 h-4" />
              {new Intl.NumberFormat().format(meta.articleViewNumber)} views
            </span>
          )}
          {meta.articleReactionNumber != null && (
            <span className="flex items-center gap-1">
              <img src={ReactStackIcon} alt="reactions" className="h-4" />
              {formatCount(meta.articleReactionNumber)}
            </span>
          )}
          {meta.articleCommentNumber != null && (
            <span className="flex items-center gap-1">
              <img src={CommentIcon} alt="comments" className="w-4 h-4" />
              {new Intl.NumberFormat().format(meta.articleCommentNumber)}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ArticleMileStone1000Notification;
